module.exports = "<div class=\"container-fluid frame\" _v-d1ece4c4=\"\"><div class=row _v-d1ece4c4=\"\"><div class=\"col-md-12 no_pad frame_group\" _v-d1ece4c4=\"\"><iframe id=iframe v-bind:src=iframeSrc _v-d1ece4c4=\"\"></iframe></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-d1ece4c4!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/pages/hdmi/iframe.vue
// module id = 1170
// module chunks = 2